import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <p className="text-xs tracking-[0.22em] uppercase font-semibold text-[#C5A059] mb-4">
          About LexIntake
        </p>
        <h1 className="font-heading text-5xl lg:text-6xl font-bold text-[#0A192F] tracking-tight leading-[1.05]">
          Built for people first.
        </h1>
        <p className="mt-6 text-lg text-slate-600 leading-relaxed">
          LexIntake is a nationwide AI-powered legal intake platform. Our
          mission is simple: when something goes wrong, people shouldn&apos;t have
          to navigate a maze of forms, jargon, and gatekeepers just to get
          their story in front of the right attorney.
        </p>
        <p className="mt-4 text-lg text-slate-600 leading-relaxed">
          We built Lexi — a calm, capable AI legal intake assistant — to
          listen first, ask the right follow-ups, and translate your situation
          into the structured case file attorneys actually need to evaluate
          your matter.
        </p>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <div className="p-8 bg-[#F8FAFC] border border-slate-200 rounded-xl">
            <h3 className="font-heading text-xl font-semibold text-[#0A192F]">
              For people with a legal issue
            </h3>
            <p className="mt-3 text-slate-600">
              Free intake. No forms. No phone tag. Just describe what happened
              and Lexi handles the rest.
            </p>
          </div>
          <div className="p-8 bg-[#F8FAFC] border border-slate-200 rounded-xl">
            <h3 className="font-heading text-xl font-semibold text-[#0A192F]">
              For attorneys & firms
            </h3>
            <p className="mt-3 text-slate-600">
              Pre-qualified, organized case files matched to your practice
              areas and jurisdictions. Subscription-based access.
            </p>
          </div>
        </div>

        <div className="mt-12 p-8 bg-[#0A192F] rounded-xl text-white">
          <h3 className="font-heading text-xl font-semibold text-[#C5A059] mb-3">
            Important
          </h3>
          <p className="text-slate-300 leading-relaxed">
            LexIntake is not a law firm. We do not provide legal advice. No
            attorney-client relationship is formed by using this service.
            Information you submit is used for legal intake and case
            organization purposes. Please consult a licensed attorney for
            legal advice.
          </p>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row gap-3">
          <Link to="/intake">
            <Button
              data-testid="about-start-case-btn"
              className="bg-[#0A192F] hover:bg-[#112A46] text-white rounded-lg px-6 py-5"
            >
              Start Free Case Review
            </Button>
          </Link>
          <Link to="/attorneys">
            <Button
              data-testid="about-attorneys-btn"
              variant="outline"
              className="rounded-lg px-6 py-5 border-slate-300 text-[#0A192F]"
            >
              For Attorneys
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
